export const JOURNALS_RESET_STATE = 'JOURNALS_RESET_STATE';
export const JOURNALS_CURRENT_ITEM = 'JOURNALS_CURRENT_ITEM';

export const JOURNALS_REQUEST_LOADING = 'JOURNALS_REQUEST_LOADING';
export const JOURNALS_REQUEST_SUCCESS = 'JOURNALS_REQUEST_SUCCESS';
export const JOURNALS_REQUEST_FAILED = 'JOURNALS_REQUEST_FAILED';

export const JOURNALS_CURRENT_ACTION = 'JOURNALS_CURRENT_ACTION';
export const JOURNALS_RESET_ACTION = 'JOURNALS_RESET_ACTION';